// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style_cardContainer__2N9lW","cardContainerList":"style_cardContainerList__9OK1B","marginVertical":"style_marginVertical__3XD7K"};